export default [
  {
    path: '/goods-of-integral',
    name: 'goods-of-integral',
    component: resolve => require(['views/goods-of-integral'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/integral-goods-group',
    name: 'integral-goods-group',
    component: resolve => require(['views/integral-goods-group'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/integral-goods-group/integral-goods-group-form/:isEdit/:id',
    name: 'integral-goods-group-form',
    props: true,
    component: resolve => require(['views/integral-goods-group-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分商品分组/积分商品分组', isForm: true }
  },
  {
    path: '/life-experience-pavilion',
    name: 'life-experience-pavilion',
    component: resolve => require(['views/life-experience-pavilion'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/life-experience-pavilion-form/:isEdit/:id',
    props: true,
    name: 'life-experience-pavilion-form',
    component: resolve => require(['views/life-experience-pavilion-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '生命体验馆/生命体验馆', isForm: true }
  },
  {
    path: '/life-experience-pavilion-reservation',
    name: 'life-experience-pavilion-reservation',
    component: resolve => require(['views/life-experience-pavilion-reservation'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/reservation-detail/:id',
    name: 'reservation-detail',
    component: resolve => require(['views/reservation-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo:'生命体验馆预约参观/生命体验馆预约参观详情' }
  },
  {
    path: '/manage-reservation',
    name: 'manage-reservation',
    component: resolve => require(['views/manage-reservation'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '生命体验馆预约参观/管理场次' }
  },
  {
    path: '/reservation-notifications',
    name: 'reservation-notifications',
    component: resolve => require(['views/reservation-notifications'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '生命体验馆预约参观/通知消息' }
  },

  {
    path: '/integral-goods-form/:isEdit/:id',
    props: true,
    name: 'integral-goods-form',
    component: resolve => require(['views/integral-goods-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分商品/积分商品', isForm: true }
  },
  {
    path: '/integral-task',
    name: 'integral-task',
    component: resolve => require(['views/integral-task'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/integral-task-detail/:id',
    name: 'integral-task-detail',
    props: true,
    component: resolve => require(['views/integral-task-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分任务/积分任务详情' }
  },
  {
    path: '/integral-task-form/:isEdit/:id',
    name: 'integral-task-form',
    props: true,
    component: resolve => require(['views/integral-task-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分任务/积分任务', isForm: true }
  },
  {
    path: '/integral-goods-detail/:id',
    props: true,
    name: 'integral-goods-detail',
    component: resolve => require(['views/integral-goods-detail'], resolve),
    meta: { auth: true, navInfo: '积分商品/积分商品详情', view: 'pc' }
  },
  {
    path: '/integral-goods-review',
    name: 'integral-goods-review',
    component: resolve => require(['views/integral-goods-review'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/integral-exchange',
    name: 'integral-exchange',
    component: resolve => require(['views/integral-exchange'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/integral-exchange-table',
    name: 'integral-exchange-table',
    component: resolve => require(['views/integral-exchange-table'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/integral-exchange-detail/:id/:operation',
    name: 'integral-exchange-detail',
    props: true,
    component: resolve => require(['views/integral-exchange-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '兑换记录/兑换记录详情' }
  },
  {
    path: '/integral-exchange-detail/:id',
    name: 'integral-refund-detail',
    props: true,
    component: resolve => require(['views/integral-exchange-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分退还审核/积分退还订单详情' }
  },
  {
    path: '/export-history/integral-exchange',
    name: 'export-history',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '兑换记录/兑换记录导出历史' }
  },
  {
    path: '/integral-particulars',
    name: 'integral-particulars',
    component: resolve => require(['views/integral-particulars'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/export-history/integral-particulars',
    name: 'export-history',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分明细/积分明细导出历史' }
  }
]
